import { Stack, Typography } from '@mui/material';

import ChatBubble from '@/karehero-app/tell-us-once/intake/ChatBubble';
import ClaimOptionCard from '@/james-playground/aa-family-claim/ClaimOptionCard';
import { voiceOf, type ClaimState } from '@/james-playground/aa-family-claim/claim/claim';
import { ROUND } from '@/james-playground/aa-family-claim/claim/claim.content';
import { SOURCE_LABEL, type Facts } from '@/james-playground/aa-family-claim/claim/facts';
import { labelOf, valueText } from '@/james-playground/aa-family-claim/claim/labels';

/**
 * Two sources disagree about an answer in this ask. The family picks one
 * before the card opens, so the card can start from it (spec 8).
 */
const ConflictChooser = ({ id, facts, claim, onPick, bubble = true }: {
  id: string;
  facts: Facts;
  claim: ClaimState;
  onPick: (keep: 'current' | 'rival') => void;
  /** In a round it is Keni asking; on the Check step it is a plain heading. */
  bubble?: boolean;
}) => {
  const v = voiceOf(claim);
  const fact = facts[id];
  if (!fact?.rival) return null;
  const readings = [
    { keep: 'current' as const, value: fact.value, source: fact.source, quote: fact.quote },
    { keep: 'rival' as const, ...fact.rival },
  ];
  return (
    <Stack spacing={1} role='radiogroup' aria-label={`${ROUND.clashTitle}: ${labelOf(id, v)}`}>
      {bubble ? (
        <ChatBubble from='keni' text={`${ROUND.clashTitle}: ${labelOf(id, v)}`} />
      ) : (
        <Typography variant='h6'>{labelOf(id, v)}</Typography>
      )}
      {readings.map((r) => (
        <ClaimOptionCard
          key={r.keep}
          control='radio'
          selected={false}
          label={valueText(id, r.value)}
          onClick={() => onPick(r.keep)}
        >
          <Typography variant='caption'>
            {SOURCE_LABEL[r.source]}
            {r.quote ? `: “${r.quote}”` : ''}
          </Typography>
        </ClaimOptionCard>
      ))}
    </Stack>
  );
};

export default ConflictChooser;
